svg {
    vertical-align: middle;

    margin: 0;
    max-width: 100%;
    height: auto;

    &:not([fill]) {
        fill: currentColor;
    }
}